import SportReport from "./SportReport";

export default SportReport;
